import {Component, OnInit, ViewChild} from '@angular/core';
import {StatCardComponent} from "../../shared/stat-card/stat-card.component";
import {CommonModule} from "@angular/common";
import {FilterBarComponent, FilterField} from "../../shared/filter-bar/filter-bar.component";
import {
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatRow,
    MatTableDataSource,
    MatTableModule
} from "@angular/material/table";
import {TripFilters, TripRecord, TripResponse} from "../../models/trip.model";
import {environment} from "../../../environments/environment";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatPaginator, MatPaginatorModule, PageEvent} from "@angular/material/paginator";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {animate, state, style, transition, trigger} from '@angular/animations';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {ExcelExportService} from "../../services/excel-export.service";
import {IncentivesService} from "../../services/incentives.service";
import {IncentiveFilters, IncentiveRecord, IncentivesResponse} from "../../models/incentives.model";
import {getCurrencySymbolFromProjectID} from "../../utils/currency.utils";
import {saveAs} from "file-saver";
import {ToastrService} from "ngx-toastr";
import {AuditLogsService} from "../../services/auditlogs.service";

@Component({
    selector: 'app-facility-incentives',
    standalone: true,
    templateUrl: './facility-incentives.component.html',
    styleUrl: './facility-incentives.component.scss',
    imports: [CommonModule, StatCardComponent, FilterBarComponent, MatTableModule, MatButtonModule, MatIconModule,
        MatProgressBarModule, MatPaginatorModule, MatSortModule, MatColumnDef, MatHeaderCell, MatCell, MatHeaderRow, MatRow,
        ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatNativeDateModule],
    providers: [
    ],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0', visibility: 'hidden'})),
            state('expanded', style({height: '*', visibility: 'visible'})),
            transition('expanded <=> collapsed', animate('150ms ease-in-out')),
        ]), trigger('chevronRotate', [
            state('collapsed', style({transform: 'rotate(0deg)'})),
            state('expanded', style({transform: 'rotate(180deg)'})),
            transition('expanded <=> collapsed', animate('180ms ease')),
        ]),
    ]
})
export class FacilityIncentivesComponent implements OnInit {

    loading: boolean = false;
    dataSource = new MatTableDataSource<IncentiveRecord>([]);
    displayedColumns: string[] = [
        'facility_name',
        'ccc',
        'enrolment_date',
        'delivery_date',
        'amount',
        'payment_type',
        'narration',
        'created_at',
    ];

    fields: FilterField[] = [
        {key: 'facility_name', type: "text", label: "Facility Name"},
        {key: 'start_date', type: "date", label: "Start Date"},
        {key: 'end_date', type: "date", label: "End Date"}
    ];

    form: FormGroup;


    total_facilities = 0;
    total_deliveries = 0;
    currency: string;
    total_amount : string;

    total = 0;
    due = 0;

    filters: IncentiveFilters = {
        page: 1,
        page_size: environment.deliveryFormPageSize,
        facility_name: null,
        start_date: null,
        end_date: null
    };
    success = 16;
    failed = 8;

    totalItems = 0;
    currentPage = 1;
    pageSize = environment.deliveryFormPageSize;

    _rows: TripRecord[] = [];

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    expandedElement: any | null = null;
    // predicate used by *matRowDef "when"
    isExpanded = (_: number, row: any) => row === this.expandedElement;


    constructor(
        private incentiveService: IncentivesService,
        private snack: MatSnackBar,
        private fb: FormBuilder,
        private excelService: ExcelExportService,
        private toaster: ToastrService,
        private auditLogsService: AuditLogsService
    ) {

        this.form = this.fb.group({
            rider_code: [''],
            start: [null],
            end: [null],
        });
    }

    ngOnInit() {
        this.currency = getCurrencySymbolFromProjectID(localStorage.getItem("orgId"));
        this.refresh(null);
    }

    private setFilters(payload?: Record<string, any> | null): void {
        if (!payload) {
            return;
        }
        this.filters = {
            page: 1,
            page_size: this.pageSize ?? environment.deliveryFormPageSize,
        };

        if (!payload) {
            return;
        }

        if (payload.facility_name != null && payload.facility_name !== '') {
            this.filters.facility_name = payload.facility_name;
        }

        if (payload.start_date != null && payload.start_date !== '') {
            this.filters.start_date = payload.start_date;
        }

        if (payload.end_date != null && payload.end_date !== '') {
            this.filters.end_date = payload.end_date;
        }
    }


    onPage(e: PageEvent) {
        this.pageSize = e.pageSize;
        this.filters.page = e.pageIndex + 1;   // API is 1-based, paginator is 0-based
        this.filters.page_size = this.pageSize;
        this.refresh(null);
    }

    onApply(payload: Record<string, any>) {
        this.refresh(payload)
    }

    onReset() {
        console.log('reset');
    }

    refresh(payload: Record<string, any>): void {
        this.loading = true;
        this.setFilters(payload);
        this.incentiveService.fetchIncentives(this.filters).subscribe({

            next: (response: IncentivesResponse) => {
                this.dataSource = new MatTableDataSource(response.items);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.total_facilities = response.total_facilities;
                this.total_deliveries = response.total_deliveries;
                this.total_amount = this.currency+" " +response.total_amount;

            }, error: (error: any) => {

            }, complete: () => this.loading = false

        });
    }



    viewTrip(row: IncentiveRecord) {
        // open a dialog or route to trip details—stub
        this.expandedElement = this.expandedElement === row ? null : row;
    }

    toExportRows(rows: IncentiveRecord[]) {
        return rows.map(row => ({
            'Facility Name': row.facility_name,
            'CCC': row.ccc,
            'Enrolment Date': row.enrolment_date,
            'Delivery Date': row.delivery_date,
            'Amount': row.amount,
            'Incentive Type': row.payment_type,
            'Created At': row.created_at,
        }));
    }

    downloadReport() {

        this.loading = true;
        let apiUrl = `${environment.apiUrl}/incentive/export`

        this.excelService.exportToExcel(this.filters, apiUrl).subscribe({
            next: (blob) => {
                saveAs(blob, "Incentives Report");
            },
            error: (error) => {
                this.toaster.error("Unable to generate incentives report");
            }
        });
        this.auditLogsService.postLog("Download incentives Report").subscribe({
            next: (response) => {

            }, error: (error) => {

            }, complete: () => this.loading = false
        });

    }

}
